import 'isomorphic-fetch';

import authService from './auth';

export const genericError = {
  message: 'Something went wrong, please try again later',
};

// Helper promise to check status of a response
export const checkResponse = response =>
  new Promise((resolve, reject) => {
    if (response.ok) {
      resolve(response);
    } else {
      // Fetch was made successfully, but response was bad
      reject(response);
    }
  });

// Resolve reponse body to JSON object or text promise
export const parseResponse = (response) => {
  const contentType = response.headers && response.headers.get('Content-Type');
  if (contentType && contentType.includes('application/json') &&
    // Because https://httpstatuses.com/204 cannot contain a body,
    // attempting to JSON.parse the empty '' will throw an error
    response.status !== 204) {
    return response.json();
  }
  return response.text();
};

// Error response may be a JSON object or something unexpected
export const parseErrorResponse = (errorResponse) => {
  // Decorate generic error with response status
  const statusError = { ...genericError, status: errorResponse.status };
  return new Promise((resolve, reject) => {
    errorResponse.json()
      .then((jsonError) => {
        // Well-formed JSON error merge
        reject({ ...statusError, ...jsonError });
      })
      .catch(() => {
        // Could not parse response as JSON
        reject(statusError);
      });
  });
};

// Handle fetch errors due to auth failures
export const handleAuthError = (error) => {
  if (error.status === 401 || error.status === 403) {
    // Unauthorized or forbidden attempt, assume client JWT is out of date, logout user
    authService.logout();
  }
  return Promise.reject(error);
};

// Fetch failed, e.g. preflight CORS or bad URL
export const handleFetchError = error =>
  Promise.reject({ ...genericError, message: error.message });

// Handle fetch JSON responses
export const handleResponse = (response, handleAuth) =>
  checkResponse(response)
    .then(parseResponse)
    .catch(parseErrorResponse)
    .catch(handleAuth && handleAuthError);


// Isomorphic fetch GET with JSON helper functions
export const fetchJSON = (url, headers = {}, requiresAuth) =>
  fetch(url, { headers })
    .catch(handleFetchError)
    .then(response => handleResponse(response, requiresAuth));

// Isomorphic fetch POST with JSON helper functions
export const postJSON = (url, headers = {}, body, requiresAuth) =>
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify(body),
  })
    .catch(handleFetchError)
    .then(response => handleResponse(response, requiresAuth));



// WEBPACK FOOTER //
// ./app/src/state/services/helpers.js